import React from 'react'
import LogoIcon from '../../assets/logo-icon.png'


const Growth = () => {
    return (
        <div className='max-w-[1350px] mx-auto px-4 py-16 text-center' >
            <div className="relative py-24 ">
                <img src={LogoIcon} alt='' className='w-[170px] mx-auto' />
                <div className="absolute w-[170px] text-center top-0 left-[50%] translate-x-[-50%]">
                    <h3 className='text-dark font-roboto-mono font-bold italic text-[24px] tracking-[6%]' >
                        Growth
                    </h3>
                    <p className='text-dark font-quicksand font-medium text-[11px] mb-4' >
                        Discover, learn and inspire through every journey
                    </p>
                </div>
                <div className="absolute w-[170px] text-center bottom-0 md:left-[40%] left-[20%] translate-x-[-50%]">
                    <h3 className='text-dark font-roboto-mono font-bold italic text-[24px] tracking-[6%]' >
                        Growth
                    </h3>
                    <p className='text-dark font-quicksand font-medium text-[11px] mb-4' >
                        Discover, learn and inspire through every journey
                    </p>
                </div>
                <div className="absolute w-[170px] text-center bottom-0 md:left-[60%] left-[80%] translate-x-[-50%]">
                    <h3 className='text-dark font-roboto-mono font-bold italic text-[24px] tracking-[6%]' >
                        Growth
                    </h3>
                    <p className='text-dark font-quicksand font-medium text-[11px] mb-4' >
                        Discover, learn and inspire through every journey
                    </p>

                </div>
            </div>

        </div>
    )
}

export default Growth
